module.exports = __webpack_public_path__ + "img/3.78c702a4.jpg";